import { combineReducers } from 'redux'
import storageSession from 'redux-persist/lib/storage/session'
import localSession from 'redux-persist/lib/storage'
import app from './app'
import loopQual from './loopQual'
import buildProduct from './buildProduct'
import cart from './cart'
import checkout from './checkout'
import submitOrder from './submitOrder'
import error from './error'
import modalWindow from './modalWindow'
import firstbill from './firstBill'
import personalInfo from './personalInfo'
import pfbautopay from './PFBAutopay'
import creditCheck from './creditCheck'
import save from './save'
import lofRegistration from './lofRegistration';
import nsi from './nsi';
import connection from './connection';
import channelLineup from './channelLineup';
import tos from './tos';
import testPage from './testPage';
import reflowTool from './reflowTool';
import xpsEntry from './xpsEntry';
//move Change
import moveExp from './moveExp';
import changeApp from './changeApp';
import updateNRTime from './nrCustInteractions';
import signIn from './validateSignIn';
import profileCart from './../reducers/profileCart';
import ecProfileCart from './../reducers/change/ecProfileCart'; // for EC FCP flow
import customTvRecommendation from './customTvRecommendation';
import supp from './supp';
import brtc from './brtc';
import tvRecommender from './../reducers/change/tvRecommender';
import disconnectvalues from './../reducers/change/disconnect';
import pega from './../reducers/change/pega';
import commonValues from './../reducers/change/common';
import vacation from './change/vacation';
import pegaRecommendation from './change/pegaRecommendation'; 
import channelReducer from '../containers/channelLineUp/reducers/zipCodeReducer';


 const appReducer = combineReducers({
  app: app,
  loopQual: loopQual,
  buildProduct: buildProduct,
  cart: cart,
  //move Change
  profileCart: profileCart,
  ecProfileCart: ecProfileCart, // for EC FCP flow
  checkout: checkout,
  error: error,
  modalWindow: modalWindow,
  firstbill: firstbill,
  submitOrder: submitOrder,
  personalInfo: personalInfo,
  creditCheck: creditCheck,
  pfbautopay: pfbautopay,
  save: save,
  lofRegistration: lofRegistration,
  nsi: nsi,
  connection: connection,
  channelLineup:channelLineup,
  tos:tos,
  testPage:testPage,
  reflowTool:reflowTool,
  updateNRTime: updateNRTime,
  xpsEntry:xpsEntry,
  //move Change
  moveExp:moveExp,
  changeApp:changeApp,
  signIn:signIn,
  customTvRecommendation:customTvRecommendation,
  supp:supp,
  brtc:brtc,
  //EC TV recommender info
  tvRecommender: tvRecommender, 
  disconnectvalues: disconnectvalues,
  pega: pega,
  commonValues: commonValues,
  vacation:vacation,
  pegaRecommendation:pegaRecommendation,
  channelReducer: channelReducer
})

const rootReducer = (state, action) => {
  if (action.type === 'CLEAR_STORE') {
    Object.keys(state).forEach(key => {
      storageSession.removeItem(`persist:${key}`);
      localSession.removeItem(`persist:${key}`);
    });
    state = undefined
  }

  return appReducer(state, action)
}

export default rootReducer;